import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { FitnessReservation, FitnessReservationsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class FitnessReservationsDataService {

  private uri: string = `${environment.apiUrl}fitness-reservations`;
  private cacheKey: string = 'fitnessReservations.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getFitnessReservation(id: number): Observable<FitnessReservation|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getFitnessReservations(parameters: {[param: string]: string | string[]}): Observable<FitnessReservationsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addFitnessReservation(data: FitnessReservation): Observable<FitnessReservation|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addFitnessReservations(data: FitnessReservation[]): Observable<FitnessReservation[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateFitnessReservation(data: FitnessReservation): Observable<FitnessReservation|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateFitnessReservations(data: FitnessReservation[]): Observable<FitnessReservation[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchFitnessReservation(data: FitnessReservation): Observable<FitnessReservation|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchFitnessReservations(data: FitnessReservation[]): Observable<FitnessReservation[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteFitnessReservation(data: FitnessReservation): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteFitnessReservations(data: FitnessReservation[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((fitnessReservation) => {
      ids.push(fitnessReservation.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
